import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { format } from "date-fns";

import { CalendarSlot, Meeting } from "../../../types";
import PatientChip from "../../chips/patient-chip";
import { getCalendarMeetingColor } from "../calendar-status-utils";

interface MonthlyMeetingInfoProps {
  meeting: CalendarSlot;
  patientLabel: string;
  onSelectMeeting: (meetingId: string) => void;
  compact?: boolean;
}

const MonthlyMeetingInfo: React.FC<MonthlyMeetingInfoProps> = ({
  meeting,
  patientLabel,
  onSelectMeeting,
  compact = false,
}) => {
  const timeFontSize = compact ? "0.66rem" : "0.72rem";
  const patientScale = compact ? 0.84 : 0.94;

  return (
    <Paper
      onClick={(event) => {
        event.stopPropagation();
        onSelectMeeting(meeting.meetingId);
      }}
      elevation={0}
      sx={{
        px: compact ? 0.45 : 0.6,
        py: compact ? 0.2 : 0.35,
        borderRadius: 1,
        border: "none",
        boxShadow: "none",
        backgroundColor: getCalendarMeetingColor(meeting),
        cursor: "pointer",
        transition: "filter 0.15s ease-in-out",
        "&:hover": {
          filter: "brightness(0.95)",
        },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: timeFontSize,
              fontWeight: 700,
              lineHeight: 1.2,
              color: "#FFFFFF",
              whiteSpace: "nowrap",
            }}
          >
            {format(new Date(meeting.startTime), "h:mm a")}
          </Typography>
        </Stack>

        <Box sx={{ transform: `scale(${patientScale})`, transformOrigin: "right center", flexShrink: 0 }}>
          <PatientChip label={patientLabel} size="small" />
        </Box>
      </Stack>
    </Paper>
  );
};

export default MonthlyMeetingInfo;
